import React, { FC, useState, useEffect } from 'react';
import { ReactComponent as ChevronRightIcon } from 'assets/icons/chevron-right.svg';
import ViewOrdersSideModal from './view-orders-modal';
import OnlineStatus from 'components/base/online-status';
import { apiService } from 'utils/api';
import { Table, TableData, TableRow } from '@cokitchen/cokitchen-components';
import { PartnerRiderType } from 'models/partner.model';
import { LiveTripRiderType } from 'models/live-trip.model';
import { STORAGE_KEYS } from 'utils/constants';
import { getUserName } from 'utils/functions';
type Props = {
  setView: () => void;
};

const TABLE_HEADERS = ['No', 'Rider name', 'Phone number', 'Email', 'Status', ''];
const LiveTripsRiderView: FC<Props> = ({ setView }) => {
  const [loading, setLoading] = useState(false);
  const [viewOrdersModal, setViewOrdersModal] = useState(false);
  const [numberOfTrips, setNumberOfTrips] = useState(0);
  const [currentRider, setCurrentRider] = useState({} as PartnerRiderType);
  const cokitchenId = localStorage.getItem(STORAGE_KEYS.COKITCHEN);

  const [localData, setLocalData] = useState<LiveTripRiderType[]>([]);
  useEffect(() => {
    if (cokitchenId) getRiders();
  }, [cokitchenId]);
  const getRiders = async () => {
    setLoading(true);
    const res = await apiService.get(`logistics/riders/live/orders/${cokitchenId}`, {
      params: {
        cokitchen_id: cokitchenId
      },
      baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
    });
    setLoading(false);
    setLocalData(res.data.data);
  };

  useEffect(() => {
    const num = localData.reduce((acc, r) => {
      acc += Array.isArray(r?.orders) ? r.orders.length : 0;
      return acc;
    }, 0);
    setNumberOfTrips(num);
  }, [localData]);

  return (
    <div className='flex flex-col gap-7 flex-wrap'>
      <div className='flex justify-between'>
        <div>
          <h1 className='font-semibold text-2xl mb-2'>Live on-going orders ({numberOfTrips})</h1>
          <p className='text-green-6'>Showing {localData.length} riders online</p>
        </div>
        <div className='flex flex-col gap-4 items-end'>
          <span
            role='button'
            className='text-[#E60A2B] text-sm underline font-medium cursor-pointer'
            onClick={setView}>
            Switch to trip view
          </span>
        </div>
      </div>
      {loading ? (
        <p className='flex justify-center my-24 text-lg '>Loading ...</p>
      ) : (
        <Table headers={TABLE_HEADERS}>
          {localData?.map((rider, index) => (
            <TableRow key={index}>
              <TableData className='text-left py-6'>{index + 1}</TableData>
              <TableData>{getUserName(rider)}</TableData>
              <TableData>{rider.phone_number}</TableData>
              <TableData>{rider.email}</TableData>
              <TableData>
                <OnlineStatus online={rider.online} />
              </TableData>
              <TableData>
                <p
                  className='text-[#F73B58] text-sm font-medium cursor-pointer flex items-center'
                  onClick={() => {
                    setViewOrdersModal(true);
                    setCurrentRider(rider);
                  }}>
                  View Orders
                  <ChevronRightIcon className='w-[18px] mt-[2px]' />
                </p>
              </TableData>
            </TableRow>
          ))}
        </Table>
      )}

      <ViewOrdersSideModal
        rider={currentRider}
        show={viewOrdersModal}
        setShow={setViewOrdersModal}
      />
    </div>
  );
};

export default LiveTripsRiderView;
